import type { SyncErrorCode, SyncState } from '@wiztime/sync';

/**
 * The values of `SyncState` from `@wiztime/sync`, repeated here. The app shell shows the sync status on
 * every screen; importing the constant from the package itself would put the whole sync code (key
 * derivation, word list) into the first-load script. The `satisfies` clause and the `Record<SyncState, ...>`
 * tables that use these values keep them in step with the package at compile time.
 */
export const SyncUiState = {
  Disabled: 'disabled',
  Idle: 'idle',
  Syncing: 'syncing',
  Offline: 'offline',
  Error: 'error',
  SpaceMissing: 'spaceMissing',
} as const satisfies Record<string, SyncState>;

/** The `SyncErrorCode` the shell reacts to, repeated for the same reason as `SyncUiState`. */
export const SyncUiError = {
  EmailUnverified: 'email_unverified',
} as const satisfies Record<string, SyncErrorCode>;
